import { render } from "./Index.vue?vue&type=template&id=0e4c24f4&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=0e4c24f4&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/elyosdigital.com/_build/workspace/MySchool/myschool.elyosdigital.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e4c24f4"],['__file',"resources/js/pages/cantine/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0e4c24f4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0e4c24f4', __exports__)) {
    console.log('reload')
    api.reload('0e4c24f4', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=0e4c24f4&scoped=true", () => {
    console.log('re-render')
    api.rerender('0e4c24f4', render)
  })

}


export default __exports__